import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DateHelper } from '../../helpers/date.helper';
import { invalidMinimumDateValidator } from '../../validators/invalid-minimum-date.directive';

@Component({
  selector: 'spv2-datepicker-no-time',
  templateUrl: './datepicker-no-time.component.html',
  styleUrls: ['./datepicker-no-time.component.scss']
})
export class DatepickerNoTimeComponent implements OnInit{
  private _value: Date | string;
  @Input() public set value(val : Date | string) {
    if(val) val = new Date(val);
    this._value = val;
    if(this.formGroup) {
      this.getDateFormControl().patchValue(val);
    }
  }
  @Output() valueChange = new EventEmitter<Date>();

  private _disabled = false;
  @Input() public set disabled(val: boolean) {
    this._disabled = val;
    if(this.formGroup){
      let dateFormControl = this.getDateFormControl();
      this._disabled ?  dateFormControl.disable() : dateFormControl.enable();
    }
  }
  
  private _minDate: Date = null;
  @Input() public set minDate(value : Date) {
    this._minDate = value;
    this.updateValidator();
  }

  @Output() isInvalidChange =  new EventEmitter<boolean>();

  public formGroup: UntypedFormGroup;

  ngOnInit(): void {
    this.formGroup = new UntypedFormGroup({
      date: new UntypedFormControl({value: this._value, disabled: this._disabled}, invalidMinimumDateValidator(this._minDate))
    });
  }

  getDateFormControl(){
    return this.formGroup.get("date");
  }

  updateValidator(){
    if(this.formGroup){
      let dateFormControl = this.getDateFormControl();
      dateFormControl.clearValidators();
      dateFormControl.setValidators(invalidMinimumDateValidator(this._minDate));
      dateFormControl.updateValueAndValidity();
    }
  }

  fixValue(date: Date) {
      if(!date) {
        this.valueChange.emit(null);
        return;
      }
      let dateFormControl = this.getDateFormControl();
      dateFormControl.patchValue(date);
      this.isInvalidChange.emit(!dateFormControl.valid);
      this.valueChange.emit(DateHelper.fixDate(dateFormControl.value));
  }
}
